module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T11-19-10.813Z.37c565a5.png";